import axios from "axios";
import { getSession } from "../Utils/SessionUtils";

const api_url = process.env.REACT_APP_API;

/* Setting the header for the axios request. */
const config = {
  headers: { Authorization: `Bearer ${getSession("token")}` },
};

//to add in every api
const currentOrg = getSession("usedorganisations");

export async function addCart(cart, id) {
  console.log('cart', cart);
  const httpHeaders = {
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.post(
      api_url + "cart/" + id,
      cart,
      httpHeaders,
    );
    return response;
  } catch (error) {
    console.error(error);
  }
}
// In your CartApi.js service
export async function closeTableSessionAndPayAll(data) {
  const httpHeaders = {
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.post(
      api_url + "cart/close_session_and_pay",
      data,
      httpHeaders,
    );
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function cancelOrder(data) {
  const httpHeaders = {
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.post(
      api_url + "cart/cancel_order",
      data,
      httpHeaders,
    );
    return response;
  } catch (error) {
    console.error(error);
    // Surface the backend's validation message (e.g. "already canceled")
    // instead of swallowing it — the caller needs it to inform the cashier.
    return error.response;
  }
}
export async function editCart(status, id, cancelMotif) {
  const body = {
    status: status,
    cancelMotif: cancelMotif,
    id: id,
  };
  const httpHeaders = {
    Authorization: `Bearer ${getSession("token")}`,
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.patch(api_url + "cart", body, httpHeaders);
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function getCarts(id) {
  if (id == null) {
    id = currentOrg;
  }
  try {
    const response = await axios.get(
      api_url + "cart/organisation/" + id,
      config,
    );
    return response;
  } catch (error) {
    console.error(error);
  }
}
export async function getTopSoldMenus(id) {
  if (id == null) {
    id = currentOrg;
  }
  try {
    const response = await axios.get(
      api_url + "cart/getTopSoldMenus/" + id,
      config,
    );
    return response;
  } catch (error) {
    console.error(error);
  }
}
export async function getActiveSession(id) {
  if (id == null) {
    return;
  }
  try {
    const response = await axios.get(
      api_url + "cart/active_session/" + id,
      config,
    );
    return response;
  } catch (error) {
    console.error(error);
  }
}
export async function getTableSessionByID(id) {
  if (id == null) {
    return;
  }
  try {
    const response = await axios.get(
      api_url + "cart/table-session-by-id/" + id,
      config,
    );
    return response;
  } catch (error) {
    console.error(error);
  }
}
export async function getTodayTableSessions(user, journal) {
  try {
    const response = await axios.get(
      api_url + `cart/caisse-sessions/${user}/${journal}`,
      config,
    );
    return response;
  } catch (error) {
    console.error(error);
  }
}
// In your CartApi.js or equivalent service file
// In your CartApi.js or equivalent service file
export async function getSessionsByDateRange(filters) {
  try {
    const response = await axios.post(
      `${api_url}cart/sessions/filter`,
      filters,
      config,
    );
    return response;
  } catch (error) {
    console.error("API Error fetching sessions:", error);
    throw error;
  }
}
export async function getCartById(id) {
  try {
    const response = await axios.get(api_url + "cart/" + id, config);
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function getLatestActiveCarts(id) {
  if (id == null) {
    id = currentOrg;
  }
  try {
    const response = await axios.get(api_url + "cart/latest/" + id, config);
    return response;
  } catch (error) {
    console.error(error);
  }
}
export async function getTableOrders(id, table) {
  if (id == null) {
    id = currentOrg;
  }
  try {
    const response = await axios.get(
      api_url + "cart/organisation/" + id + "/" + table,
      config,
    );
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function closeOrders(table, organisation_id) {
  const body = {
    table: table,
    organisation_id: organisation_id,
  };
  const httpHeaders = {
    Authorization: `Bearer ${getSession("token")}`,
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.patch(
      api_url + "cart/close",
      body,
      httpHeaders,
    );
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function getTableNotPaidOrders(id, table) {
  if (id == null) {
    id = currentOrg;
  }
  try {
    const response = await axios.get(
      api_url + "cart/notpaid/" + id + "/" + table,
      config,
    );
    return response;
  } catch (error) {
    console.error(error);
  }
}
export async function getAllNotPaidOrders(id) {
  if (id == null) {
    id = currentOrg;
  }
  try {
    const response = await axios.get(api_url + "cart/notpaid/" + id, config);
    return response;
  } catch (error) {
    console.error(error);
  }
}
export async function updateTableSession(id, data) {
  try {
    const response = await axios.put(
      api_url + `cart/table_session`,
      { id, data },
      config,
    );
    return response;
  } catch (error) {
    console.error("Error fetching cash parametrage:", error);
    throw error;
  }
}
export async function getOrderAnalytics(data) {
  try {
    const response = await axios.get(api_url + `cart/analytics/summary`, {
      ...config, // Keep your headers/auth from existing config
      params: data, // This turns {organisation_id: 1} into ?organisation_id=1
    });
    return response;
  } catch (error) {
    console.error("Error fetching analytics:", error);
    throw error;
  }
}
export async function getProductPerformance(data) {
  try {
    const response = await axios.get(
      api_url + `cart/analytics/product-performance`,
      {
        ...config,
        params: data,
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching product performance:", error);
    throw error;
  }
}